import { autoinject, computedFrom, transient, useView } from "aurelia-framework";
import { VesselDetailModel, GetModelLastRunResponse } from "../../../../../models/vessels/vessel.models";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { MobileHelper } from "../../../../../helpers/mobile-helper";
import { VesselDetailsDetails } from "./vessel-details-tabs/vessel-details-details";
import { VesselDetailsVettingAttributes } from "./vessel-details-tabs/vessel-details-vetting-attributes";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { Reflection } from "../../../../../utilities/reflection";

class VesselDetailsTab {
    title: string;
    vm: any;
    path: string;
    model?: any;
    isVisible: boolean;
    key?: string;
}

@autoinject
@transient()
@useView('views/pages/modules/vessels/steps/vessel-details.html')
export class VesselDetails {

    public tabs: VesselDetailsTab[] = [];
    public currentTab: VesselDetailsTab;
    public model: { vessel: VesselDetailModel };
    public modelResponse: GetModelLastRunResponse;

    constructor(public vesselDetailsDetails: VesselDetailsDetails,
        private vesselDetailsVettingAttributes: VesselDetailsVettingAttributes,
        private userClaimsService: UserClaimsService,
        private manageVesselService: ManageVesselService) {
    }

    async activate(model: { vessel: VesselDetailModel }) {
        this.model = model;
        
        if(model && model.vessel && Object.keys(model.vessel).filter(x => model.vessel[x] != undefined).length == 2 &&
         Object.keys(model.vessel).indexOf('vesselId') > -1 &&
         Object.keys(model.vessel).indexOf('internationalMaritimeOrganizationNumber') > -1)
        {
            const resp = await this.manageVesselService.getVessel({
                vesselId: model.vessel.vesselId,
                imo: model.vessel.internationalMaritimeOrganizationNumber,
                bKey: model.vessel.bKey
            });
            
            this.model.vessel = resp && resp.vessel ? resp.vessel : model.vessel;
        }

        this.tabs = [
            {
                title: "Vessel details",
                vm: this.vesselDetailsDetails,
                path: "views/pages/modules/vessels/steps/vessel-details-tabs/vessel-details-details",
                isVisible: true,
                model: {
                    vessel: this.model.vessel
                }
            },
            {
                title: "Vetting attributes",
                vm: this.vesselDetailsVettingAttributes,
                path: "views/pages/modules/vessels/steps/vessel-details-tabs/vessel-details-vetting-attributes",
                model: {
                    id: this.model.vessel.vesselId,
                    entityType: EntityTypes.Vessel,
                    hasSave: true
                },
                isVisible: this.userClaimsService.hasPermission(Claims.CanAccessVettingAttributes)
            }
        ];

        if (this.tabs.filter(x => x.isVisible).length > 0)
            this.navigateToTab(this.tabs.filter(x => x.isVisible)[0]);
    }


    @computedFrom(Reflection.getPropertyPath<VesselDetails>(z => z.tabs), Reflection.getPropertyPath<VesselDetails>(z => z.tabs.length))
    public get tabsVisibleCount() {
        return this.tabs.filter(x => x.isVisible == true).length;
    }

    public getViewModel(name: string) {
        if (name) {
            require( name +'.ts')
            require( name +'.html')
            return name
        }
    }

    navigateToTab(tab: VesselDetailsTab) {
        this.currentTab = tab;
        this.scrollToTop();
    }

    scrollToTop() {
        const scrollElement = MobileHelper.getScrollParent(document.getElementsByClassName('page-vessel').item(0), false) as HTMLDivElement;

        setTimeout(() => {
            if (scrollElement) {
                scrollElement.scrollTop = 0;
            }
        });
    }
}